module.exports = __webpack_public_path__ + "media/packs/images/cost/truck-a42427507bf9a448f93beb0ca2421d3f.svg";